import NotificationsContent from './NotificationsContent'
export default NotificationsContent
